import './styles/custom.css'
import { CookiesProvider } from 'react-cookie'
import { createRoot } from 'react-dom/client'
import AppRoutes from './app/routes'
import { StoreProvider } from './context/StoreContext'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <CookiesProvider>
    <StoreProvider>
      <AppRoutes />
    </StoreProvider>
  </CookiesProvider>,
)
